const UINT256_LIMIT = 1n << 256n;

export type RedeemFeeAmountsInput = {
  vaultPoolWei: bigint; quoteFeeWei: bigint; creatorTaxWei: bigint;
  protocolShareBps: bigint; rewardBps: bigint; buybackEnabled: boolean;
};

/** Estimated sweep amounts; vaultPoolWei alone is the settled source pool. */
export function calculateRedeemFeeQuote(input: RedeemFeeAmountsInput) {
  if (input.buybackEnabled !== false) throw new Error("BUYBACK_UNSUPPORTED");
  for (const value of [input.vaultPoolWei, input.quoteFeeWei, input.creatorTaxWei]) {
    if (typeof value !== "bigint" || value < 0n || value >= UINT256_LIMIT) throw new RangeError("Invalid uint256 fee amount");
  }
  if (typeof input.protocolShareBps !== "bigint" || input.protocolShareBps < 0n || input.protocolShareBps > 10_000n ||
    typeof input.rewardBps !== "bigint" || input.rewardBps <= 0n || input.rewardBps > 10_000n) throw new RangeError("Invalid fee or reward bps");
  const creatorFromBaseWei = input.quoteFeeWei - input.quoteFeeWei * input.protocolShareBps / 10_000n;
  const poolAfterSweepWei = input.vaultPoolWei + creatorFromBaseWei + input.creatorTaxWei;
  if (poolAfterSweepWei >= UINT256_LIMIT) throw new RangeError("Post-sweep pool exceeds uint256");
  const payoutWei = poolAfterSweepWei * input.rewardBps / 10_000n;
  return { vaultPoolWei: input.vaultPoolWei, quoteFeeWei: input.quoteFeeWei, creatorFromBaseWei,
    creatorTaxWei: input.creatorTaxWei, protocolShareBps: input.protocolShareBps,
    rewardBps: input.rewardBps, poolAfterSweepWei, payoutWei };
}
